import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import AuthService from "../../services/auth/Auth";
import ThemeService from "../../services/theme/Theme";
import CartService from "../../services/cart/Cart";
import SettingService from "../../services/setting/Setting";
import { setUser } from "../../store/action/auth";
import { themeChanged } from "../../store/action/theme";
import { cartsChanged } from "../../store/action/cart";
import { settingChanged } from "../../store/action/setting";
import HttpService from "../../services/http_service/HttpService";

const PrimitiveData = (props) => {
  const { children, setUser, themeChanged, cartsChanged, settingChanged } =
    props;

  const [loading, setLoading] = useState(true);

  const setCart = useCallback(() => {
    CartService.setCart(CartService.getCart(), cartsChanged);
  }, [cartsChanged]);

  const setTheme = useCallback(() => {
    ThemeService.setTheme(ThemeService.getTheme(), themeChanged);
  }, [themeChanged]);

  const setUserData = useCallback(() => {
    const getUser = AuthService.getUser();

    AuthService.setUser(getUser, setUser);

    HttpService(getUser?.token)
      .post("services/available")
      .then((response) => {
        SettingService.setSetting(response.data?.entity?.value, settingChanged);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [setUser, settingChanged]);

  useEffect(() => {
    setCart();
    setTheme();
    setUserData();
  }, [setUserData, setTheme, setCart]);

  return <>{loading ? false : children}</>;
};

export default connect(false, {
  setUser,
  themeChanged,
  cartsChanged,
  settingChanged,
})(PrimitiveData);
